
export default class ImgLoaded {

  constructor(urls, callback) {
    this.imgUrls = urls;
    this.callback = callback;

    this.imgCount = urls.length;
    this.counter = 0;

    this.items = [];

    this.load();
  }

  load() {
    this.imgUrls.forEach((src, i) => {
      // imageオブジェクト
      const img = new Image();
      img.addEventListener('load', this.loaded.bind(this), false);
      img.addEventListener('error', this.error.bind(this), false);
      img.src = src;

      this.items.push({
        img: img,
        index: i
      });
    });
  }

  loaded(e) {
    // image数カウント
    this.counter++;
    if (this.imgCount === this.counter) {
      this.callback(this.items);
    }
  }

  error(e) {
    console.log('ERROR: ', e);
  }
}
